<div class="app-container app-theme-white body-tabs-shadow fixed-header fixed-sidebar closed-sidebar">
    <app-header></app-header>
    <div class="app-main">
        <!-- Menu Section --->
        <app-menus></app-menus>
        <!-- Menu section End -->
        <div class="app-main__outer">
            <div class="app-main__inner">
                <div class="app-page-title">
                    <div class="page-title-wrapper">
                        <div class="page-title-heading">
                            <div class="page-title-icon">
                                <i class="pe-7s-graph icon-gradient bg-plum-plate"></i>
                            </div>
                            <div>Dashboard
                                <div class="page-title-subheading">Empowering You with Real-Time Updates and Assistance
                                </div>
                            </div>
                        </div>
                        <!-- will remove in next commit - commented on 01-04-2025 -->
                        <!-- <div class="page-title-actions">
                            <button type="button" aria-haspopup="true" aria-expanded="false" data-toggle="dropdown"
                                class="dropdown-toggle btn btn-primary" #dropdownButton>
                                SO Number (Project Name):<b> {{ selectedSoNumberProjectNo ? selectedSoNumberProjectNo :
                                    'Select SO No' }} </b>
                            </button>
                            <div tabindex="-1" role="menu" aria-hidden="true" class="dropdown-menu" #dropdownMenu>
                                <h6 tabindex="-1" class="dropdown-header">Select Project</h6>
                                <button *ngFor="let soList of soList" type="button" tabindex="0" class="dropdown-item"
                                    [ngClass]="{ 'active': selectedSoNumber === soList.id }"
                                    (click)="onSelectSoNumber(soList)">
                                    {{ soList.name }}
                                </button>
                            </div>
                        </div> -->
                        <div class="page-title-actions" ngbDropdown #dropdown="ngbDropdown">
                            <button type="button" class="btn btn-primary" id="dropdownMenuButton" ngbDropdownToggle>
                              SO Number (Project Name): <b>{{ selectedSoNumberProjectNo ? selectedSoNumberProjectNo : 'Select SO No' }}</b>
                            </button>
                            <div ngbDropdownMenu aria-labelledby="dropdownMenuButton">
                              <h6 class="dropdown-header">Select Project</h6>
                              <button *ngFor="let soList of soList; trackBy: trackById" 
                                      type="button" 
                                      class="dropdown-item"
                                      [ngClass]="{ 'active': selectedSoNumber === soList.id }"  
                                      (click)="onSelectSoNumber(soList); dropdown.close()">
                                {{ soList.name }}
                              </button>
                            </div>
                          </div>                         
                          
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12 col-md-5 col-lg-5">
                        <div class="mb-3 card">
                            <div class="card-header-tab card-header">
                                <div
                                    class="card-header-title font-size-lg text-capitalize font-weight-normal d-flex flex-wrap align-items-center">
                                    <i class="header-icon lnr-rocket icon-gradient bg-tempting-azure me-2"></i>
                                    <h6 class="mb-0 text-nowrap">
                                        <div class="opacity-7 header-text-dashboard">Project Status
                                        </div>
                                        <span class="header-text-dashboard" *ngIf="selectedSoNumberProjectNo">
                                            {{ selectedSoNumberProjectNo }}
                                        </span>
                                    </h6>
                                </div>
                            </div>

                            <div class="p-0 card-body">
                                <div>
                                    <!-- <span class="header-text-dashboard">Current Gate: P1 sales order release gate</span> -->
                                    <apx-chart *ngIf="ProgressChartOptions" [series]="ProgressChartOptions.series"
                                        [chart]="ProgressChartOptions.chart" [title]="ProgressChartOptions.title"
                                        [subtitle]="ProgressChartOptions.subtitle"
                                        [plotOptions]="ProgressChartOptions.plotOptions"
                                        [labels]="ProgressChartOptions.labels" [stroke]="ProgressChartOptions.stroke"
                                        [fill]="ProgressChartOptions.fill"></apx-chart>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-7 col-lg-7">
                        <div class="mb-3 card">
                            <div class="card-header-tab card-header">
                                <div class="card-header-title font-size-lg text-capitalize font-weight-normal">
                                    <i class="header-icon lnr-rocket icon-gradient bg-tempting-azure"></i>
                                    <h6 class="mb-0 text-nowrap">
                                        <div class="opacity-7 header-text-dashboard">Gate Wise Status
                                        </div>
                                        <!-- <span class="header-text-dashboard">
                                            {{ selectedSoNumberProjectNo ? selectedSoNumberProjectNo :
                                                'Select SO No' }}
                                        </span> -->
                                    </h6>
                                </div>
                            </div>
                            <div class="pt-0 card-body">
                                <div>
                                    <apx-chart *ngIf="GatewiseChartOptions" [series]="GatewiseChartOptions.series"
                                        [chart]="GatewiseChartOptions.chart"
                                        [dataLabels]="GatewiseChartOptions.dataLabels"
                                        [plotOptions]="GatewiseChartOptions.plotOptions"
                                        [xaxis]="GatewiseChartOptions.xaxis" [stroke]="GatewiseChartOptions.stroke"
                                        [fill]="GatewiseChartOptions.fill" [yaxis]="GatewiseChartOptions.yaxis"
                                        [title]="GatewiseChartOptions.title" [tooltip]="GatewiseChartOptions.tooltip"
                                        [legend]="GatewiseChartOptions.legend"
                                        [colors]="GatewiseChartOptions.colors"></apx-chart>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12 col-md-5 col-lg-5">
                        <div class="card-hover-shadow-2x mb-3 card">
                            <div class="card-header-tab card-header">
                                <div class="card-header-title font-size-lg text-capitalize font-weight-normal">
                                    <i class="header-icon lnr-database icon-gradient bg-malibu-beach"> </i>
                                    <span class="header-text-dashboard">Service Call / Complaint</span>
                                </div>
                            </div>
                            <div class="scroll-area-lg">
                                <div class="scrollbar-container">
                                    <div class="p-2">
                                        <ul class="todo-list-wrapper list-group list-group-flush">
                                            <div *ngIf="taskListData">
                                                <div *ngFor="let data of taskList;">
                                                    <li class="list-group-item">
                                                        <div class="todo-indicator bg-primary"></div>
                                                        <div class="widget-content p-0">
                                                            <div class="widget-content-wrapper">
                                                                <div class="widget-content-left">
                                                                    <div class="widget-heading">{{data?.task_number}}
                                                                        <div *ngIf="data?.status=='1'"
                                                                            class="badge badge-info ml-2">Open</div>
                                                                        <div *ngIf="data?.status=='2'"
                                                                            class="badge badge-warning ml-2">WIP</div>
                                                                    </div>
                                                                    <div class="widget-subheading">
                                                                        {{data?.subject}}
                                                                    </div>
                                                                    <div class="widget-subheading"><i
                                                                            [innerHTML]="data?.issue_details.length > 100 ? (data?.issue_details | slice:0:100) + '...' : data?.issue_details"></i>
                                                                    </div>
                                                                </div>
                                                                <div class="widget-content-right">
                                                                    <div class="badge badge-success mr-2">
                                                                        {{data?.department?.name}}</div>
                                                                </div>
                                                                <div
                                                                    class="widget-content-right widget-content-actions">
                                                                    <button (click)="openComplaint(data?.id,2)"
                                                                        class="border-0 btn-transition btn btn-outline-primary">
                                                                        <i class="fa fa-eye"></i>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                </div>
                                            </div>
                                            <div *ngIf="!taskListData" class="widget-content p-0">
                                                <li class="list-group-item">
                                                    <div class="todo-indicator bg-primary"></div>
                                                    <div class="widget-content p-0">
                                                        <div class="widget-content-wrapper">
                                                            <div class="widget-content-left">
                                                                <div class="widget-heading">No open service calls or
                                                                    complaints at the moment.
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                            </div>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="d-block text-right card-footer">
                                <!-- <button class="mr-2 btn btn-link btn-sm">Cancel</button> -->
                                <button (click)="openComplaint(data?.id,1)" class="btn btn-primary">Add New</button>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-7 col-lg-7">
                        <div class="mb-3 card">
                            <div class="card-header-tab card-header">
                                <div class="card-header-title font-size-lg text-capitalize font-weight-normal">
                                    <i class="header-icon lnr-rocket icon-gradient bg-tempting-azure"></i>
                                    <h6 class="mb-0 text-nowrap header-text-dashboard">
                                        <div class="opacity-7">Detailed Task
                                            Status Gate wise
                                        </div>
                                        <!-- <span class="header-text-dashboard">
                                            {{ selectedSoNumberProjectNo ?
                                                selectedSoNumberProjectNo :
                                                'Select SO No' }}
                                        </span> -->
                                    </h6>
                                </div>
                            </div>
                            <div class="pt-0 card-body">
                                <div>
                                    <apx-chart *ngIf="chartOptions" [series]="chartOptions.series"
                                        [chart]="chartOptions.chart" [dataLabels]="chartOptions.dataLabels"
                                        [plotOptions]="chartOptions.plotOptions" [xaxis]="chartOptions.xaxis"
                                        [stroke]="chartOptions.stroke" [fill]="chartOptions.fill"
                                        [yaxis]="chartOptions.yaxis" [title]="chartOptions.title"
                                        [tooltip]="chartOptions.tooltip" [legend]="chartOptions.legend"></apx-chart>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <form [formGroup]="proposalFrm">
                    <div class="card no-shadow bg-transparent no-border rm-borders mb-3">
                        <div class="card">
                            <div class="no-gutters row">
                                <div class="col-md-12 col-lg-5">
                                    <ul class="list-group list-group-flush">
                                        <li class="bg-transparent list-group-item">
                                            <div class="widget-content p-0">
                                                <div class="widget-content-outer">
                                                    <div class="widget-content-wrapper">
                                                        <div class="widget-content-left">
                                                            <div class="widget-heading">External Schedule Report</div>
                                                        </div>
                                                        <div class="widget-content-right">
                                                            <div class="widget-numbers text-success"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-12 col-lg-5">
                                    <ul class="list-group list-group-flush">
                                        <li class="bg-transparent list-group-item">
                                            <div class="widget-content p-0">
                                                <div class="widget-content-outer">
                                                    <div class="widget-content-wrapper">
                                                        <div class="widget-content-left">
                                                            <div class="widget-heading">SO Number (Project Name)</div>
                                                            <div class="widget-subheading">{{ selectedSoNumberProjectNo
                                                                ? selectedSoNumberProjectNo :
                                                                'Select SO No' }}</div>
                                                        </div>
                                                        <div class="widget-content-right">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-12 col-lg-2">
                                    <ul class="list-group list-group-flush">
                                        <li class="bg-transparent list-group-item">
                                            <div class="widget-content p-0">
                                                <div class="widget-content-outer">
                                                    <div class="widget-content-wrapper">
                                                        <div class="widget-content-left">
                                                            <div class="widget-heading"><button
                                                                    class="mt-2  mr-2 btn btn-primary" name="submit"
                                                                    type="submit" (click)="onSubmit()">Download</button>
                                                            </div>
                                                            <div class="widget-subheading"></div>
                                                        </div>
                                                        <div class="widget-content-right">
                                                            <div class="widget-numbers text-success"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div *ngIf="chat_visibility" class="chat-button" (click)="openchatwindow()">
            <img src="assets/images/icon/chat.png" alt="Chat Icon" />
        </div>
    </div>
</div>
<div class="app-drawer-overlay d-none animated fadeIn"></div>